import React, { useState } from "react";
import "./otpSection.scss";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import TextBox from "../../atoms/textbox";
import ButtonInput from "../../atoms/button";
import backButton from "../../assets/images/arrow-left.svg";
import { Box, CircularProgress } from "@mui/material";

import { updateUserData, verifyOtpApi } from "../../redux/action/user";

const OtpSection = (props) => {
  const [enableButton, setEnableButton] = useState(true);
  const [loading, setLoading] = useState(false);

  const otpChange = (value) => {
    const digitsOnly = String(value || "").replace(/\D/g, "").slice(0, 6);

    props.updateUserData({
      ...props.user,
      otp: digitsOnly,
    });

    setEnableButton(digitsOnly.length !== 6);
  };

  const loginClick = async () => {
    if (!props.user?.otp || String(props.user.otp).length !== 6) {
      toast.error("Please enter the 6-digit verification code");
      return;
    }

    setLoading(true);
    try {
      await verifyOtpApi({
        email: props.user.email || props.user.userName,
        otp: props.user.otp,
      });
      props.updateUserData({
        ...props.user,
        status: "confirmPassword",
        userName: props.user.email || props.user.userName,
      });
    } catch (error) {
      toast.error(error?.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  const gotoForgotPassword = () => {
    props.updateUserData({
      ...props.user,
      status: "LoginForgotPassword",
      otp: "",
      isNewUser: false,
    });
  };

  return (
    <div className="login_form">
      <div className="container-fluid">
        <div className="row">
          <h2 className="title">Don't Worry, We're here to help you!</h2>
          <p className="subTitle">
            Enter the verification code you received on your email.
          </p>
        </div>
        <Box mb={3} mt={1}>
          <TextBox
            placeholder="Verification code"
            value={props.user?.otp}
            valueChange={otpChange}
          />
        </Box>
        <div>
          <ButtonInput
            text={
              loading ? <CircularProgress size={25} color="success" /> : "VERIFY"
            }
            onSubmit={loginClick}
            disabled={enableButton || loading}
          />
          <ButtonInput
            text="Back"
            class="back-button"
            onSubmit={gotoForgotPassword}
            iCon={backButton}
          />
        </div>
      </div>
    </div>
  );
};

OtpSection.propTypes = {};
OtpSection.defaultProps = {};

const actionCreators = {
  updateUserData,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(OtpSection);
